import styled from "styled-components";
import Contacts from "../ui/contacts/Contacts";
import { IMAGES } from "../../constants/images";

const Footer = () => {
  return (
    <StyledFooter>
      <div className="footer_container">
        <div className="logo-container">
          <div className="logo-text-container">
            <img src={IMAGES.HZS_LOGO} alt="logo" height="80" />
            <h2 className="text">
              Defensible <span>space</span> viewer
            </h2>
          </div>
        </div>
        <div className="additional-contacts">
          <Contacts />
          <a className="privacy-policy" href="https://hozesolutions.com/data-protection/" target="_blank" rel="noreferrer">
            Privacy policy
          </a>
        </div>
      </div>
      <span className="copyright-text">© HoZe Solutions GmbH</span>
    </StyledFooter>
  );
};

const StyledFooter = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  .footer_container {
    min-height: 120px;
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  .logo-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;

    .logo-text-container {
      display: flex;
      align-items: center;
      gap: 10px;
      .text {
        margin: 0;
        text-transform: uppercase;
        font-size: 40px;
        font-weight: 700;
        span {
          color: rgba(0, 0, 255, 1);
        }
      }
    }
  }

  .additional-contacts {
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    justify-content: end;
    a {
      color: rgba(0, 0, 255, 1);
    }

    .privacy-policy{
      margin-top: 10px;
    }
  }

  @media (max-width: 850px) {
    .footer_container {
      flex-direction: column;
    }

    .copyright-text {
      display: block;
      margin-top: 20px;
    }
  }
`;

export default Footer;
